import { ROUTES } from '@/routes';

const TOKEN_PARAM = 'token';
const TOKEN_ROUTES: readonly string[] = [ROUTES.resetPassword, ROUTES.verifyEmail];

let captured: { pathname: string; token: string } | null = null;

/**
 * Moves a reset or verification `token` from the address bar into memory and replaces the history entry without it. Call once at startup, before the app renders, so the token is not visible while the session is restored.
 */
export function captureUrlToken() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(TOKEN_PARAM);
  if (!token || !TOKEN_ROUTES.includes(url.pathname)) return;

  captured = { pathname: url.pathname, token };
  url.searchParams.delete(TOKEN_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

/** The token `captureUrlToken` took for `pathname`, if any. */
export function getCapturedUrlToken(pathname: string): string | null {
  return captured?.pathname === pathname ? captured.token : null;
}
